<template>
	<div class="flex flex-grow">
		<div class="md:gap-1 flex-grow items-baseline">
			<div class="flex">
				<BaseInput
					class="w-3/6 pr-2"
					:label="$t('name_of_bank')"
					ref="BaseInput.company.bankAccount.bank"
					type="text"
					:required="true"
					v-model="companyData.bankAccount.bank"
				/>
				<BaseInput
					:label="$t('iban')"
					ref="BaseInput.company.bankAccount.iban"
					type="tel"
					:required="true"
					class="w-2/6 pl-2 pr-2"
					mask="AANN NNNN NNNN NNNN NNNN NNNN NNNN NNNN NN"
					v-model="companyData.bankAccount.iban"
				/>
				<BaseInput
					class="w-1/6 pl-2"
					:label="$t('bic')"
					ref="BaseInput.company.bankAccount.bic"
					type="text"
					:required="true"
					v-model="companyData.bankAccount.bic"
				/>
			</div>
			<div class="flex space-x-4">
				<BaseInput
					class="w-1/2"
					:label="$t('tax_number')"
					:required="true"
					ref="BaseInput.company.taxNumber"
					type="text"
					v-model="companyData.taxNumber"
					v-if="!isUserAllowedInLevel3"
				/>
				<BaseInput
					class="w-1/2"
					:label="$t('tax_number')"
					:required="!companyData.sales_tax || (companyData.sales_tax && companyData.taxNumber)"
					ref="BaseInput.company.taxNumber"
					type="text"
					v-model="companyData.taxNumber"
					v-if="isUserAllowedInLevel3"
				/>
				<BaseInput
					class="w-1/2"
					:label="$t('ust_id')"
					:required="!companyData.taxNumber || (companyData.sales_tax && companyData.taxNumber)"
					ref="BaseInput.company.sales_tax"
					type="text"
					v-model="companyData.sales_tax"
					v-if="isUserAllowedInLevel3"
				/>
				<BaseInput
					v-if="!isUserAllowedInLevel2 && !isUserAllowedInLevel3"
					class="w-1/2"
					:label="$t('district_court')"
					ref="BaseInput.company.amtsgericht"
					:required="false"
					type="text"
					v-model="companyData.amtsgericht"
				/>
				<BaseInput
					v-else
					class="w-1/2"
					:label="$t('address_internet')"
					ref="BaseInput.company.homepage"
					:required="false"
					validationtype="domain"
					type="text"
					v-model="companyData.homepage"
				/>
			</div>
			<div class="flex space-x-4" v-if="!isUserAllowedInLevel2 && !isUserAllowedInLevel3">
				<div class="w-1/2 flex gap-4">
					<BaseSelect
						class="w-1/2"
						:options="hrOptions"
						ref="BaseSelect.company.hr"
						:label="$t('trading_register')"
						:required="false"
						v-model="companyData.hr"
					/>
					<BaseInput
						class="w-1/2"
						:label="$t('number')"
						ref="BaseInput.company.hrNumber"
						:required="false"
						type="text"
						v-model="companyData.hrNumber"
					/>
				</div>
				<BaseInput
					class="w-1/2"
					:label="$t('address_internet')"
					ref="BaseInput.company.homepage"
					:required="false"
					validationtype="domain"
					type="text"
					v-model="companyData.homepage"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import BaseSelect from '@/components/forms/inputs/BaseSelect';
import BaseInput from '@/components/forms/inputs/BaseInput.vue';
import Authentication from '@/mixins/Authentication';
import Validate from '@/mixins/Validate';

export default {
	components: { BaseSelect, BaseInput },
	name: 'OnboardingCompanyDataLegalForm',
	mixins: [Validate, Authentication],
	data() {
		return {
			companyData: { bankAccount: {}, hr: null },
			hrOptions: [
				{
					display: 'HRA',
					value: 'hra',
				},
				{
					display: 'HRB',
					value: 'hrb',
				},
			],
		};
	},
	mounted() {
		//  this.companyData.hr = this.hrOptions[0]
	},
	methods: {
		getData() {
			return this.companyData;
		},
	},
};
</script>
